var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navBar'),(_vm.userProfile.data().userRole.toLowerCase() === 'admin' || _vm.userProfile.data().userRole.toLowerCase() === 'super admin')?_c('adminDrawer'):_c('generalDrawer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }